import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  list: [],
  recentSearchedList: [],
  detail: {},

  page: 1,
  totalPage: 2,
  limit: 10,
  pageInfo: {}
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
